import { render, staticRenderFns } from "./MessageTemplateHistoryComponent.vue?vue&type=template&id=c933f08e&scoped=true&"
import script from "./MessageTemplateHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateHistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateHistoryComponent.vue?vue&type=style&index=0&id=c933f08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c933f08e",
  null
  
)

export default component.exports